import { ApiError } from "../../api/apiError";
import { requestErrorText, type TFunction } from "../queue/requestErrorText";

const HTTP_FORBIDDEN = 403;
const HTTP_NOT_FOUND = 404;
const HTTP_CONFLICT = 409;

const CODE_RUNNER_NOT_FOUND = "runner_not_found";
const CODE_RUNNER_HAS_NO_QUEUE = "runner_has_no_queue";
const CODE_RUNNER_HAS_BLOCKING_TASKS = "runner_has_blocking_tasks";
const CODE_PERMISSION_DENIED = "permission_denied";

// Раннера нет или он уже снят: `404` с кодом `runner_not_found`.
export function isRunnerNotFound(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.status === HTTP_NOT_FOUND &&
    err.code === CODE_RUNNER_NOT_FOUND
  );
}

// Текст ошибки операции над раннером (регистрация/перевыпуск/снятие) по
// паре статус + `code` (ADR-0091 § 7–8). `403` обрабатывается реактивно, по
// ответу backend: набор прав клиента (`useMyPermissions`) — подсказка и
// может устареть (ADR-0080). Технический `message` и текст сервера не
// выводятся; прочее — общий текст по статусу или «нет связи».
export function runnerErrorText(err: unknown, t: TFunction): string {
  if (err instanceof ApiError) {
    if (
      err.status === HTTP_CONFLICT &&
      err.code === CODE_RUNNER_HAS_BLOCKING_TASKS
    ) {
      const taskCount = err.data.blocking_task_count;
      return typeof taskCount === "number"
        ? t("runners.retire.blocked", { taskCount })
        : t("runners.retire.blockedUncounted");
    }
    if (isRunnerNotFound(err)) {
      return t("runners.notFound");
    }
    if (
      err.status === HTTP_NOT_FOUND &&
      err.code === CODE_RUNNER_HAS_NO_QUEUE
    ) {
      return t("runners.reissue.noQueue");
    }
    if (err.status === HTTP_FORBIDDEN && err.code === CODE_PERMISSION_DENIED) {
      return t("runners.forbidden");
    }
  }
  return requestErrorText(err, t);
}
